export * from './codigo-critica-detalhe-conferencia-fatura.pipe';
